import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { PaymentReviewRecord } from "./paymentReviewRecord"
import {
  IPaymentReviewRecord,
  PaymentReviewFailureErrorCode,
  PaymentReviewRecordStatus,
} from "./paymentReviewRecord.types"
import dayjs from "dayjs"
import { safeNumber } from "@/helpers/objectHelpers"
import { GetPaymentReviewRecordsQuery } from "@/api/hasura/generated/graphql"
import { formatAccountNumber } from "@/helpers/accountHelper"
import { safeDayjs } from "@/helpers/dateHelper"

export type PaymentReviewRecordRaw =
  GetPaymentReviewRecordsQuery["payment_review_records_view"][0]

export const PaymentReviewRecordParser: IParser<
  IPaymentReviewRecord,
  PaymentReviewRecordRaw
> = {
  toDomain: (data) => {
    try {
      return new PaymentReviewRecord(
        data.id,
        formatAccountNumber(data.account_number ?? ""),
        data.status as PaymentReviewRecordStatus,
        dayjs(data.created_at),
        (data.failure_error_code as PaymentReviewFailureErrorCode) ?? undefined,
        safeDayjs(data.next_payment_date),
        safeNumber(data.payment_schedule_period_amount),
        safeNumber(data.new_monthly_amount),
        safeNumber(data.changed_amount),
        safeNumber(data.change_percentage),
        safeNumber(data.account_balance),
        safeNumber(data.estimate_annual_cost),
        safeDayjs(data.last_retry_time),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
